/* eslint-disable no-unused-vars */
import { initialState } from './state'
import { PayloadAction } from '@reduxjs/toolkit'
import {
  SaleOfferFilterProjectKey,
  SaleOfferDetailsStateKey,
  CreateSaleOfferStateKey,
  UserSaleOffersStateKey,
  AllSaleOffersStateKey,
  ActionSaleOfferKey,
  SaleOfferGroupKey,
  SaleOffersState,
  SaleOfferStatus,
  UserSaleOffer,
} from 'src/core/models'

const reducers = {
  // All Sale Offers
  setAllSaleOffersGroupValue: (state: SaleOffersState, action: PayloadAction<AllSaleOffersStateKey>) => {
    state.allSaleOffers[String(action.payload.key)]= action.payload.value
  },
  resetAllSalesOfferState: (state: SaleOffersState) => {
    state.allSaleOffers = initialState.allSaleOffers
  },
  // Sale Offers Group
  setSaleOffersGroupValue: (state: SaleOffersState, action: PayloadAction<SaleOfferGroupKey>) => {
    state.offerGroups[String(action.payload.key)]= action.payload.value
  },
  resetSalesOfferGroupCreateState: (state: SaleOffersState) => {
    state.offerGroups.creatingLoading = false
    state.offerGroups.successCreate = false
    state.offerGroups.errorCreate = false
  },
  resetSalesOfferState: (state: SaleOffersState) => {
    state = initialState
  },
  // Filter Project
  resetFilterProjectOfferState: (state: SaleOffersState) => {
    state.filterProject = initialState.filterProject
  },
  setSaleOfferFilterProjectValue: (state: SaleOffersState, action: PayloadAction<SaleOfferFilterProjectKey>) => {
    state.filterProject[String(action.payload.key)]= action.payload.value
  },
  // Create Sale Offer
  setCreateSaleOfferValue: (state: SaleOffersState, action: PayloadAction<CreateSaleOfferStateKey>) => {
    state.createSaleOffer[String(action.payload.key)]= action.payload.value
  },
  resetCreateSaleOfferState: (state: SaleOffersState) => {
    state.createSaleOffer = initialState.createSaleOffer
  },
  // User Sale Offers
  setUserSaleOffersValue: (state: SaleOffersState, action: PayloadAction<UserSaleOffersStateKey>) => {
    state.userSaleOffers[String(action.payload.key)]= action.payload.value
  },
  resetUserSaleOffersState: (state: SaleOffersState) => {
    state.userSaleOffers = initialState.userSaleOffers
  },
  // User Sale Offers
  setSaleOfferDetailsValue: (state: SaleOffersState, action: PayloadAction<SaleOfferDetailsStateKey>) => {
    state.saleOfferDetails[String(action.payload.key)]= action.payload.value
  },
  resetSaleOfferDetailsState: (state: SaleOffersState) => {
    state.saleOfferDetails = initialState.saleOfferDetails
  },
  // Accept Sale Offer
  setAcceptSaleOfferValue: (state: SaleOffersState, action: PayloadAction<ActionSaleOfferKey>) => {
    state.acceptOffer[String(action.payload.key)]= action.payload.value
  },
  resetAcceptSaleOfferState: (state: SaleOffersState) => {
    state.acceptOffer = initialState.acceptOffer
  },
  // Reject Sale Offer
  setRejectSaleOfferValue: (state: SaleOffersState, action: PayloadAction<ActionSaleOfferKey>) => {
    state.rejectOffer[String(action.payload.key)]= action.payload.value
  },
  resetRejectSaleOfferState: (state: SaleOffersState) => {
    state.rejectOffer = initialState.rejectOffer
  },
  // Make Counter Offer
  setCounterSaleOfferValue: (state: SaleOffersState, action: PayloadAction<ActionSaleOfferKey>) => {
    state.makeCounterOffer[String(action.payload.key)]= action.payload.value
  },
  resetCounterSaleOfferState: (state: SaleOffersState) => {
    state.makeCounterOffer = initialState.makeCounterOffer
  },

  // Ui Reducers
  updateSaleOfferStatusOnList: (
    state: SaleOffersState,
    action: PayloadAction<{ offerId: number, status: SaleOfferStatus}>
  ) => {
    const { offerId, status } = action.payload
    const oldList = state.userSaleOffers.data
    const newList = oldList.map(offer => {
      if (offer.id === offerId) return { ...offer, status }
      return offer
    })
    state.userSaleOffers.data = newList
  },
  updateAdminSaleOfferStatusOnList: (
    state: SaleOffersState,
    action: PayloadAction<{ offerId: number, status: SaleOfferStatus}>
  ) => {
    const { offerId, status } = action.payload
    const oldList = state.allSaleOffers.data
    const newList = oldList.map(group => {
      if (!group.sale_offers.some(o => o.id === offerId)) { return group }
      const newSaleOffers = group.sale_offers.map(offer => {
        if (offer.id === offerId) return { ...offer, status }
        return offer
      })
      return { ...group, sale_offers: newSaleOffers }
    })
    state.allSaleOffers.data = newList
  },
  addNewSaleOffer: (state: SaleOffersState, action: PayloadAction<UserSaleOffer>) => {
    const oldList = state.userSaleOffers.data
    const newList = [action.payload, ...oldList]
    state.userSaleOffers.data = newList
  }
}

export default reducers
